<template>
    <div>
        <div class="container" style="display: flex; flex-direction: column; ">
        <div class="row py-3">
            <div class="col-12 d-flex align-items-center border-bottom">
                <span class="mx-2 pt-2 col-1" style="font-weight: bold; font-family: 'Avenir-Heavy'; ">To</span>
                <slot name="to-field">
                    <span  class="subject-field">
                        {{ newsletterData.mail_data.user.email }}
                    </span>
                </slot>
            </div>
        </div>
        <div class="row py-3">
            <div class="col-12 d-flex align-items-center border-bottom">
                <span class="mx-2 col-1" style="font-weight: bold; font-family: 'Avenir-Heavy'; ">Subject</span>
                <slot name="subject-field">
                    <span class="subject-field">{{newsletterData.html.subject}}</span>
                </slot>
            </div>
        </div>
    </div>
    <iframe ref="email-frame"
    style="width: 100%; min-height: 700px;border: none;" 
    ></iframe>
    </div>
  </template>
  
  <script>
  export default {
    components: {  },
      name: 'newsletterPreviewer',
      props: ["newsletterData"],
      mounted() {
        this.$refs['email-frame'].contentDocument.write(this.newsletterData.html.html);
        this.disableClickEvents(); 
      },
      methods: {
          disableClickEvents() {
              // Select all anchor tags that might be used as buttons and disable their behavior
              const iframeDocument = this.$refs['email-frame'].contentDocument;
              const clickableElements = iframeDocument.querySelectorAll('a');
              clickableElements.forEach(element => {
                  element.style.pointerEvents = 'none';
              });
          }
      },
  };
  </script>
  
  <style lang="scss" scoped>
  .subject-field {
    margin-left: 1.25rem !important;
    }
    .border-bottom{
        border-bottom: 1px solid #e4e6ef;
    }
  </style>